// tslint:disable
export var PharmacySpecialization;
(function (PharmacySpecialization) {
    // OTH
    PharmacySpecialization[PharmacySpecialization["OTH"] = 0] = "OTH";
    // CRP
    PharmacySpecialization[PharmacySpecialization["CRP"] = 1] = "CRP";
    // SPR
    PharmacySpecialization[PharmacySpecialization["SPR"] = 2] = "SPR";
    // CMP
    PharmacySpecialization[PharmacySpecialization["CMP"] = 3] = "CMP";
    // HIT
    PharmacySpecialization[PharmacySpecialization["HIT"] = 4] = "HIT";
    // CLP
    PharmacySpecialization[PharmacySpecialization["CLP"] = 5] = "CLP";
    // MOP
    PharmacySpecialization[PharmacySpecialization["MOP"] = 6] = "MOP";
    // MCO
    PharmacySpecialization[PharmacySpecialization["MCO"] = 7] = "MCO";
    // IFT
    PharmacySpecialization[PharmacySpecialization["IFT"] = 8] = "IFT";
    // PRC
    PharmacySpecialization[PharmacySpecialization["PRC"] = 9] = "PRC";
    // NFS
    PharmacySpecialization[PharmacySpecialization["NFS"] = 10] = "NFS";
})(PharmacySpecialization || (PharmacySpecialization = {}));
//# sourceMappingURL=PharmacySpecialization.js.map